export default {
    imageDashboardTransaction: {
        action: 'Ação',
        transactionId: 'ID da transação',
        variationCount: 'Contagem de Variações',
        date: 'Data',
        cost: 'Custo',
        description: 'Descrição',
        selectedImage: 'Imagem selecionada',
        goTo: 'Ir para',
    },
};
